import { useQuery } from '@apollo/client'
import { FunctionComponent, useState } from 'react'
import { GET_USER_BRANDS, QueryGetUserBrandsResponse } from '../../gql'
import {
  GetUserBrandsResponse,
  GetUserBrandsOptions,
  GetUserBrandsSort,
  User,
  QueryGetUserBrandsArgs,
} from '../../gql/types'
import { Loader, ListOptions } from '../../components'
import { List } from './components/List'
import { SKIP_DEFAULT, LIMIT_DEFAULT } from '../../utils/constants'

interface IProps {
  user: User
}

const SwitchBrands: FunctionComponent<IProps> = ({ user }) => {
  const [options, setOptions] = useState<GetUserBrandsOptions>({
    query: null,
    filters: {},
    sort: GetUserBrandsSort.newest,
    skip: SKIP_DEFAULT,
    limit: LIMIT_DEFAULT,
  })

  // Get all user brands with settings
  const { loading, data } = useQuery<
    QueryGetUserBrandsResponse,
    QueryGetUserBrandsArgs
  >(GET_USER_BRANDS, {
    variables: {
      options,
    },
  })

  const [query, setQuery] = useState('')
  const onSearch = () => {
    setOptions({
      ...options,
      query,
      filters: {
        ...options.filters,
      },
    })
  }

  const setPage = (page: number) => {
    setOptions({
      ...options,
      skip: page * options.limit,
    })
  }

  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <div className='sm:flex sm:items-center py-4 px-1'>
        <div className='sm:flex-auto'>
          <h1 className='font-bold text-3xl font-outfit'>Switch Brands</h1>
          <p className='mt-1 text-sm text-gray-500'>
            Switch between your brands and control which ones appear in your
            sidebar menu.
          </p>
        </div>
      </div>

      <div className='pb-4 w-auto h-fit'>
        <div className='overflow-x-auto'>
          <div className='inline-block min-w-full py-2 px-1 align-middle'>
            <div className='overflow-hidden shadow  md:w-auto ring-1 ring-black ring-opacity-5 rounded-t'>
              <ListOptions
                onSearch={onSearch}
                query={query}
                setQuery={setQuery}
                className='p-2'
              />
              <List
                userBrands={data?.getUserBrands?.items || []}
                pagination={data?.getUserBrands?.pagination}
                setPage={setPage}
                loading={loading}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { SwitchBrands }
